import { createGlobalStyle } from 'styled-components'

const GLobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    font-family: 'Quicksand', sans-serif;
    color: #222;
    font-weight: 500;
  }
`

export default GLobalStyle
